<template>
  <div>
    <!--
    <b-card no-body >
      <b-card-body>
        <span>Programación de Fertilización</span>
      </b-card-body>
    </b-card>
    -->

    <b-card no-body v-if="estadoTablaAsistentes" >
      <b-card-body>
        <b-row>
          <b-col lg="1">
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-button
                  variant="gradient-primary"
                  size="sm"
                  @click="estadoTablaAsistentes = false"
                  id="btn_back"
              >
                <font-awesome-icon icon="fa-solid fa-arrow-left-long"/>
              </b-button>
              <b-tooltip
                  title="Regresar"
                  target="btn_back"
              />
            </b-form-group>
          </b-col>
          <b-col lg="11">
            <h4 class="text-bold font-weight-bold font-medium-1">Mostrando {{ items2.length }} asistentes para el tema:  {{ tema }}</h4>
          </b-col>
        </b-row>
      </b-card-body>

      <b-table
          hover
          responsive
          small
          class="position-relative tablitaA"
          sticky-header="58vh"
          :per-page="perPage"
          :current-page="currentPage"
          :items="items2"
          :fields="fields2"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">

            <feather-icon
                :id="`btn_${data.item.id}_mostrarFotoFirma`"
                icon="ImageIcon"
                size="16"
                class="mx-1"
                @click="mostrarFoto(false, data.item.firma_foto, data.item.nombres)"
            />
            <b-tooltip
                title="Ver foto / firma"
                :target="`btn_${data.item.id}_mostrarFotoFirma`"
            />

          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
        <template #cell(fecha)="data">
          <span class="text-nowrap" v-if="data.value === null || data.value === '' || data.value === ' '"></span>
          <span class="text-nowrap" v-else>
            {{
              new Date(data.value.split('-')).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
        </template>
        <template #cell(asistente)="data">
          <span class="text-nowrap">
            <!-- {{ data.item.asistentes.length }} -->
          </span>
        </template>

      </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
    </b-card>

    <b-card no-body v-else>
      <div class="m-2">
        <b-row>
          <b-col
              cols="12"
              lg="5"
              class="d-flex align-items-center justify-content-start mb-1 mb-lg-0"
          >
            <b-button
                title="Actualizar Registros"
                variant="gradient-primary"
                size="sm"
                class="mr-1"
                @click="rellenarVacios"
                :disabled="loadingASI"
            >
              <span v-if="loadingASI">Actualizando asistentes &emsp; <font-awesome-icon icon="fa-solid fa-arrows-rotate" spin/></span>
              <span v-else>Actualizar asistentes &emsp; <font-awesome-icon icon="fa-solid fa-arrows-rotate"/></span>
              <!-- <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loadingASI"/> -->

            </b-button>
            <b-form-group
                label-for="filterInput"
                class="mb-0"
            >
              <b-input-group size="sm">
                <b-form-input
                    id="filterInput"
                    v-model="busqueda"
                    placeholder="Búsqueda"
                />
                <b-input-group-append>
                  <b-button
                      variant="gradient-primary"
                      :disabled="!busqueda"
                      @click="buscar"

                  >
                    Buscar
                  </b-button>
                  <b-button
                      variant="gradient-danger"
                      :disabled="!busqueda"
                      @click="itemsFiltro = items; busqueda = ''"
                  >
                    Resetear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-button
                v-if="$can('create', 'Capacitaciones')"
                variant="gradient-primary"
                size="sm"
                @click="exportarFilePDF"
                :disabled="loadingPDF"
                class="ml-1"
            >
              <span v-if="loadingPDF">
                <font-awesome-icon icon="fa-solid fa-arrows-rotate" spin/>
                <b><i>&emsp; Generando PDF </i></b>
              </span>
              <span v-else>
                PDF <font-awesome-icon icon="fa-solid fa-file-pdf"/>
              </span>
            </b-button>
          </b-col>
          <b-col
              cols="12"
              lg="4"
          >
            <div class="d-flex align-items-center justify-content-center">
              <label class="text-bold font-weight-bold font-medium-1" v-if="asistente!==null"> {{ "Asistente: " + asistente }} </label>
              <label class="text-bold font-weight-bold font-medium-1" v-else> </label>
            </div>
          </b-col>
          <b-col
              cols="12"
              lg="3"
          >
            <div class="d-flex align-items-center justify-content-end">
              <label class="text-bold font-weight-bold font-medium-1">Mostrando {{ itemsFiltro.length }} de {{items.length}} registros</label>
            </div>
          </b-col>
        </b-row>
      </div>

      <b-table
          hover
          responsive
          small
          class="position-relative tablitaA"
          sticky-header="58vh"
          :per-page="perPage"
          :current-page="currentPage"
          :items="itemsFiltro"
          :fields="fields"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="cPaginacion"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>
        <template #cell(acciones)="data">
          <div class="text-nowrap">

            <feather-icon
                :id="`btn_${data.item.id}_mostrarFoto`"
                icon="ImageIcon"
                size="16"
                class="mx-1"
                @click="mostrarFoto(true, data.item.foto_capacitacion, data.item.tema)"
            />
            <b-tooltip
                title="Ver foto / firma"
                :target="`btn_${data.item.id}_mostrarFoto`"
            />

            <feather-icon
                :id="`btn_${data.item.id}_mostrarAsistentes`"
                icon="UsersIcon"
                size="16"
                class="mx-1 text-warning"
                @click="mostrarAsistente(data.item.id, data.item.tema)"
            />
            <b-tooltip
                title="Ver asistentes"
                :target="`btn_${data.item.id}_mostrarAsistentes`"
            />

          </div>
        </template>
        <template #cell(estado)="data">
          <b-badge :variant="status[1][parseInt(data.value)]">
            {{ status[0][parseInt(data.value)] }}
          </b-badge>
        </template>
        <template #cell(fecha)="data">
          <span class="text-nowrap" v-if="data.value === null || data.value === '' || data.value === ' '"></span>
          <span class="text-nowrap" v-else>
            {{
              new Date(data.value.split('-')).toLocaleString('pe-PE', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                localeMatcher: 'best fit',
                timeZone: 'America/Lima'
              })
            }}
          </span>
        </template>
        <template #cell(asistente)="data">
          <span class="text-nowrap">
            <!-- {{ data.item.asistentes.length }} -->
          </span>
        </template>
        <template #cell(n_acta)="data">
          <span class="text-nowrap">
            {{ data.value.toString().padStart(6, '0') }}
          </span>
        </template>

        <template #head(empresa)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${empresa_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${empresa_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>EMPRESA</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Empresa" label-for="empresa_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="empresa_filtro"
                      v-model="empresa_filtro"
                      :options="empresaFiltro"
                      multiple
                      placeholder="Seleccionar empresa ..."
                      @input="realizarFiltro('empresa', empresa_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="empresa_filtro=[]; realizarFiltro('empresa', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(tema)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${tema_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${tema_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>TEMA</b>
              </template>
              <b-dropdown-form style="width: 350px!important;">
                <b-form-group label="Filtrar Tema" label-for="tema_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="tema_filtro"
                      v-model="tema_filtro"
                      :options="temaFiltro"
                      multiple
                      placeholder="Seleccionar tema ..."
                      @input="realizarFiltro('tema', tema_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="tema_filtro=[]; realizarFiltro('tema', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>
        <template #head(area_responsable)>
          <div class="text-nowrap">
            <b-dropdown
                menu-class=""
                size="sm"
                variant="btn"
                :toggle-class="`${area_responsable_filtro.length>0 ? 'text-primary font-weight-bolder p-1' : 'font-weight-bolder p-1'}`"
                :style="`${area_responsable_filtro.length>0 ? 'text-decoration: underline #fba820e6;' : ''}`"
            >
              <template #button-content>
                <b>ÁREA RESPONSABLE</b>
              </template>
              <b-dropdown-form style="width: 250px!important;">
                <b-form-group label="Filtrar Área Responsbale" label-for="area_responsable_filtro" @click.prevent class="py-0 my-0">
                  <v-select
                      id="area_responsable_filtro"
                      v-model="area_responsable_filtro"
                      :options="area_responsableFiltro"
                      multiple
                      placeholder="Seleccionar area_responsable ..."
                      @input="realizarFiltro('area_responsable', area_responsable_filtro)"
                      class="select-size-sm"
                  />
                </b-form-group>
              </b-dropdown-form>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item @click="area_responsable_filtro=[]; realizarFiltro('area_responsable', [])">
                <feather-icon class="mr-1" icon="DeleteIcon" />
                <span class="align-middle">Borrar Filtro</span>
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </template>

      </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
    </b-card>


    <b-modal
        id="modalVerFotos"
        v-model="verFoto"
        ok-title="Aceptar"
        ok-only
        :title="this.tema"
        scrollable
    >
      <b-row>
        <b-col
            lg="12"
        >
          <b-card
              :img-src="imagen"
              text-variant="white"
              img-alt="card img"
              body-class="bg-overlay"
          >
          </b-card>
        </b-col>
      </b-row>
    </b-modal>

  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'

import {
  BBadge,
  BButton,
  BCard,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BModal,
  BPagination,
  BSpinner,
  BTable,
  BRow,
  BCol,
  BDropdownDivider,
  BTooltip,
  BInputGroupAppend,
  BInputGroup,
  BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import jsPDF from 'jspdf'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,
    flatPickr,
    BDropdown, BDropdownForm, BDropdownItem, BDropdownHeader,

    vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
  },
  data: () => ({
    loading: false,
    loading2: false,
    loadingPDF: false,
    loadingASI: false,
    estadoTablaAsistentes: false,
    items: [],
    items2: [],
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 0,
    currentPage: 1,
    filter: null,
    filterOn: [],
    fields: [
      {
        key: 'acciones',
        label: '#',
        thClass: 'text-center py-0 alinear-medioA',
        class: 'px-0 text-center',
        stickyColumn: true,
      },
      {
        key: 'estado',
        label: 'estado',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'tema',
        label: 'tema',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'expositor',
        label: 'expositor',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'fecha',
        label: 'fecha',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'hora_inicio',
        label: 'hora inicio',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'hora_fin',
        label: 'hora fin',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'total_horas',
        label: 'Tiempo estimado',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'n_acta',
        label: 'N° Acta',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'participantes',
        label: 'participantes',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'asistente',
        label: 'Asistentes',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'empresa',
        label: 'empresa',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'area_responsable',
        label: 'Área Responsable',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
    ],
    fields2: [
      {
        key: 'acciones',
        label: '#',
        thClass: 'text-center py-0 alinear-medioT',
        class: 'px-0 text-center',
        stickyColumn: true,
      },
      {
        key: 'dni',
        label: 'dni',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'text-center alinear-una-sola-linea',
      },
      {
        key: 'nombres',
        label: 'nombres',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'cargo',
        label: 'cargo',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'area',
        label: 'area',
        sortable: true,
        thClass: 'text-center py-0 alinear-medioA',
        tdClass: 'alinear-una-sola-linea',
      },
    ],
    status: [
      {
        0: 'Pendiente',
        1: 'En Proceso',
        3: 'Ejecutado',
      },
      {
        0: 'light-warning',
        1: 'light-info',
        3: 'light-success',
      }
    ],
    tema: null,
    imagen: null,
    verFoto: false,
    sideImg: require('@/assets/images/logo/agvLogo.png'),
    sideImg2: require('@/assets/images/logo/arvLogo.png'),
    selloAgv: require('@/assets/images/logo/sello_agv.png'),
    selloArv: require('@/assets/images/logo/sello_arv.png'),
    imgAsBase64: "",

    fechaFiltro: null,
    itemsFiltro: [],
    filtro: [
      {nombre: "empresa", valor: []},
      {nombre: "tema", valor: []},
      {nombre: "area_responsable", valor: []},
      {nombre: "fecha", valor: []}
    ],
    empresaFiltro: [],
    temaFiltro: [],
    area_responsableFiltro: [],

    empresa_filtro: [],
    tema_filtro: [],
    area_responsable_filtro: [],

    busqueda: null,
    asistente: null,

    // validation rules
    required,
  }),
  computed: {},
  mounted() {
    this.traerCapaAsis();
    localize("es");
  },
  methods: {
    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    rellenarVacios(){
      const yo = this
      yo.loadingASI = true

      const config = {
        method: 'get',
        url: '/capacitacion/asistentes/exportar/rellenar/'
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){

              //Si todo salió bien, envío mensaje
              yo.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Función ejecutada exitosamente',
                      icon: 'CheckIcon',
                      text: 'Se actualizaron con éxito los datos de '+ response.data['updates'] +' asistentes.',
                      variant: 'success',
                    },
                  },
                  {
                    position: 'top-center',
                  })

            }

          })
          .catch(function (error) {
            console.log(error);
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: 'Error en la Actualización',
                icon: 'XIcon',
                text: 'Hubo un error en la actualización de registros, intentelo nuevamente en unos minutos.',
                variant: 'danger',
              },
            })
          })
          .finally(function (){
            yo.loadingASI = false
          })
    },

    mostrarNotificacion(titulo, icono, texto, variante, tiempo){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: tiempo,
            position: 'top-center',
          })
    },

    traerCapaAsis(){
      const yo = this
      yo.loading = true


      const config = {
        method: 'get',
        url: '/capacitacion/capacitaciones_anidado/'
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data;
              yo.totalRows = yo.items.length
              yo.empresaFiltro = []
              yo.temaFiltro = []
              yo.area_responsableFiltro = []

              for (let value of yo.items){
                if(value.empresa !== null && value.empresa !== '' && value.empresa !== ' ' && value.empresa !== '  ') { yo.empresaFiltro.push(value.empresa) }
                if(value.tema !== null && value.tema !== '' && value.tema !== ' ' && value.tema !== '  ') { yo.temaFiltro.push(value.tema) }
                if(value.area_responsable !== null && value.area_responsable !== '' && value.area_responsable !== ' ' && value.area_responsable !== '  ') { yo.area_responsableFiltro.push(value.area_responsable) }
              }

              yo.empresaFiltro = [...new Set(yo.empresaFiltro)].sort()
              yo.temaFiltro = [...new Set(yo.temaFiltro)].sort()
              yo.area_responsableFiltro = [...new Set(yo.area_responsableFiltro)].sort()

              yo.empresaFiltro.push('VACIOS')
              yo.temaFiltro.push('VACIOS')
              yo.area_responsableFiltro.push('VACIOS')

              yo.itemsFiltro = yo.items

            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          })
    },

    handleSubmit() {
      this.$refs.formularioFertilizacion.validate().then(success => {
        if (success)  {
          this.items.push(
              {
                "id":this.items.length+1,
                "semana":23,
                "cultivo":this.cultivo,
                "etapa_fen":'PRODUCTIVA',
                "empresa":this.empresa,
                "fundo":this.fundo,
                "etapa":this.etapa,
                "campo":this.campo,
                "turno":this.turno,
                "variedad":this.variedad,
                "lote":this.lote,
                "valvula":this.valvula,
                "area":this.area,
                "cod_producto":this.codigo,
                "producto":this.producto,
                "grupo_producto":this.grupo,
                "subgrupo_producto":null,
                "und_medida":this.uni_med,
                "dias":this.dias,
                "kg_ha_dia":this.kg_ha_dia,
                "total_max_dia":this.total_max_dia,
                "lun":this.lunes,
                "mar":this.martes,
                "mie":this.miercoles,
                "jue":this.jueves,
                "vie":this.viernes,
                "sab":this.sabado,
                "dom":this.domingo,
                "estado":"0"
              })
          // Hide the modal manually
          this.$nextTick(() => {
            this.$refs['my-modal'].toggle('#toggle-btn')
          })
        }
      })
    },

    resetModal() {
      this.name = ''
      this.nameState = null

      this.cultivo= null
      this.empresa= null
      this.fundo= null
      this.etapa= null
      this.campo= null
      this.turno= null
      this.variedad= null
      this.lote= null
      this.valvula= null
      this.area= null
      this.codigo= null
      this.producto= null
      this.grupo= null
      this.uni_med= null
      this.dias= null
      this.kg_ha_dia= null
      this.total_max_dia= "0.0"
      this.lunes= "0.0"
      this.martes= "0.0"
      this.miercoles= "0.0"
      this.jueves= "0.0"
      this.viernes= "0.0"
      this.sabado= "0.0"
      this.domingo= "0.0"
      this.indicador= "0.0"
    },

    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },

    seleccionarTurno(){
      console.log(this.turno)
      if(this.turno === 'TURNO 1-A'){
        this.lote = '3005-3006-3007-3008'
        this.valvula = '04-03-02-01'
        this.variedad = 'BILOXI'
        this.area = '11.09'
      }else{
        this.lote = '3001-3002-3003-3004'
        this.valvula = '08-07-06-05'
        this.variedad = 'BILOXI'
        this.area = '11.32'
      }
    },

    buscarProducto(){
      if(this.codigo === '2510041'){
        this.producto = '4CROPS MICROMIX (I.AHIERRO 20,ZINC 35GL)'
        this.grupo = 'FERT-BIOESTI-BIOREG'
        this.uni_med = 'L'
      }else if(this.codigo === '2510044'){
        this.producto = '4RESIST K (I.A FOSFITO POTASIO)'
        this.grupo = 'FERT-BIOESTI-BIOREG'
        this.uni_med = 'L'
      }
    },

    calcularMaxDia(){
      const kg = this.kg_ha_dia
      const are = this.area
      this.total_max_dia = (kg * are).toLocaleString('es-PE', {maximumFractionDigits: 2})
    },
    // -------------------------------
    mostrarAsistente(id, tema){
      const yo = this
      yo.loading = true

      yo.tema = tema
      // yo.items2 = datos
      yo.estadoTablaAsistentes = true

      // ---------i
      const data = JSON.stringify(
          {
            "id": id
          }
      )

      const config = {
        method: 'post',
        url: '/capacitacion/asistentes/exportar/filter/',
        headers: {
          'Content-Type': 'application/json'
        },
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              yo.items2=response.data;
              yo.totalRows = yo.items2.length
            }
          })
          .catch(function (error) {
            console.log(error);

          })
          .finally(function () {
            yo.loading = false
          });

    },

    mostrarFoto(estado, foto, tema){
      const yo = this
      yo.tema = estado ? "Mostrando foto de la capacitación: " + tema : "Validación de asistencia de: " + tema
      yo.verFoto = true
      yo.imagen = foto
    },

    exportarFile(){
      const yo = this
      const spd = yo.itemsFiltro
      const arrayFInal = []
      let cont1 = 0;
      let cont2 = 0;

      if (spd.length > 0){
        spd.forEach(function(value) {
          cont1++
          cont2 = 0
          value.asistentes.forEach(function (valor) {
            cont2++
            arrayFInal.push(
                {
                  "n_acta": valor.n_acta,
                  "posicion": cont2,
                  "anio": "2022",
                  "dni": valor.dni,
                  "nombres": valor.nombres,
                  "puesto": valor.cargo,
                  "unidad": value.unidad,
                  "planilla": value.planilla,
                  "tema": value.tema,
                  "temario": value.temario,
                  "area_responsable": value.area_responsable,
                  "escuela": value.escuela,
                  "actividad": value.actividad,
                  "modalidad": value.modalidad,
                  "categoria": value.categoria,
                  "fecha": value.fecha,
                  "hora_inicio": value.hora_inicio,
                  "hora_fin": value.hora_fin,
                  "total_horas": value.total_horas,
                  "mes_ejecutado": "SETIEMBRE",
                  "empresa": value.empresa,
                  "sede": value.sede,
                  "departamento": value.departamento,
                  "area": value.area,
                  "seccion": value.seccion,
                  "zona": value.zona,
                  "dni_expositor": value.dni_expositor,
                  "expositor": value.expositor,
                  "procedencia_expositor": value.procedencia_expositor,
                  "semana": "37",
                }
            )
          })
        })

        const data = JSON.stringify(
            {
              "datas":arrayFInal,
            }
        )

        const config = {
          method: 'post',
          url: '/capacitacion/capacitaciones/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        };

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {

                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', "Reporte de Capacitaciones Internas.xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();

                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loading_exp = false
            });
      }else{
        yo.$toast(
            {
              component: ToastificationContent,
              props: {
                title: '¡Advertencia!',
                icon: 'AlertTriangleIcon',
                text: 'No se encuentran registros para exportar.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            }
        )
      }
    },

    exportarFilePDF() {
      const yo = this
      const spd = yo.itemsFiltro

      for (const value of spd){
        yo.loadingPDF = true
        const data = JSON.stringify(
            {
              "id": value.id
            }
        )

        const config = {
          method: 'post',
          url: '/capacitacion/asistentes/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(async function (response) {
              if (response.status === 200) {
                const asistentes = response.data
                let ini = -7
                let fin = 12

                const imgLogo = value.empresa === 'AGROVISION' ? yo.sideImg : yo.sideImg2
                const imgSello = value.empresa === 'AGROVISION' ? yo.selloAgv : yo.selloArv

                const totalHojas = value.n_asistentes > 12 ? Math.ceil((value.n_asistentes - 12) / 20) + 1 : 1

                const doc = new jsPDF({
                  orientation: 'p',
                  unit: "mm", // Dimensiones A4: 210 x 297 mm
                  format: "a4"
                })

                for (let j = 1; j <= totalHojas; j++) {
                  if (j === 1) {
                    doc.setLineWidth(0.4)
                    doc.rect(7.5, 7.5, 195, 15)
                    doc.setLineWidth(0.225)
                    doc.line(46.5, 7.5, 46.5, 22.5)
                    doc.line(163.5, 7.5, 163.5, 22.5)
                    doc.line(46.5, 15, 163.5, 15)

                    doc.addImage(imgLogo, "PNG", 20.5, 8.5, 13, 13, "agv", "NONE", 0)
                    doc.addImage(imgSello, "PNG", 176, 268.5, 13, 13, "selloagv", "NONE", 0)
                    value.firma_expositor !== null && value.firma_expositor !== '' ? await doc.addImage("https://images.weserv.nl/?url=" + value.firma_expositor, "PNG", 113, 268.5, 20, 13, "firmaexp", "NONE", 0) : ""

                    doc.setFontSize(8)
                    doc.text("FORMATO", 105, 11.25, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("REGISTRO DE INDUCCIÓN, CAPACITACIÓN, ENTRENAMIENTO Y SIMULACRO", 105, 18.75, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.setFontSize(6);
                    doc.text(`Código: GH-GD-FO-0609\nRevisión: 006\nFecha: 03/12/2021\nPágina: 1 de ${totalHojas}`, 165, 12.125, { align: 'left' })

                    doc.line(162.5, 282.5, 202.5, 282.5)
                    doc.line(102.5, 282.5, 142.5, 282.5)

                    doc.line(182.5, 28.5, 202.5, 28.5)
                    doc.text(value.n_acta != null ? `${value.n_acta.toString()
                        .padStart(6, '0')}` : '0'.padStart(6, '0'), 192.5, 27.75, { align: 'center' })
                    doc.setFont(undefined, 'bold')
                    doc.text("CÓDIGO DE ACTA: ", 181.5, 27.75, { align: 'right' })
                    doc.setFontSize(8)
                    doc.text("TEMA:", 7.5, 33)
                    doc.text("TEMARIO:", 7.5, 39)
                    doc.text("V°B° C&D", 182.5, 287, {
                      align: 'center',
                      baseline: 'bottom'
                    })
                    doc.text("FIRMA DEL EXPOSITOR", 122.5, 285.75, {
                      align: 'center',
                      baseline: 'bottom'
                    })
                    doc.text(value.dni_expositor != null ? `DNI: ${value.dni_expositor}` : "DNI: --", 122.5, 289.5, {
                      align: 'center',
                      baseline: 'bottom'
                    })
                    doc.setFontSize(6.75)
                    doc.setFont(undefined, 'normal')
                    doc.text(value.tema != null ? value.tema : "--", 23.5, 33)
                    doc.line(23, 33.75, 202.5, 33.75)
                    doc.line(23, 39.75, 202.5, 39.75)
                    doc.line(23, 43.75, 202.5, 43.75)
                    doc.text(value.temario != null ? value.temario : "--", 23.5, 39, {
                      align: 'justify',
                      lineHeightFactor: 1.75,
                      maxWidth: 177.5
                    })

                    doc.setLineWidth(0.4)
                    doc.rect(7.5, 47.75, 195, 60)
                    doc.setLineWidth(0.225)
                    doc.line(7.5, 55.75, 202.5, 55.75)
                    doc.line(7.5, 63.75, 202.5, 63.75)
                    doc.line(151, 73, 195, 73)
                    doc.line(7.5, 75.75, 202.5, 75.75)
                    doc.line(7.5, 83.75, 202.5, 83.75)
                    doc.line(7.5, 91.75, 202.5, 91.75)
                    doc.line(7.5, 99.75, 202.5, 99.75)

                    doc.line(144, 47.75, 144, 55.75)
                    doc.line(105, 55.75, 105, 63.75)

                    doc.line(42.5, 75.75, 42.5, 83.75)

                    doc.line(56.25, 83.75, 56.25, 91.75)
                    doc.line(153.75, 83.75, 153.75, 91.75)

                    doc.line(97.5, 91.75, 97.5, 99.75)
                    doc.line(137.5, 91.75, 137.5, 99.75)

                    doc.line(105, 99.75, 105, 107.75)

                    doc.line(31.875, 115.75, 80.625, 115.75)
                    doc.line(129.375, 115.75, 178.125, 115.75)

                    let pp = 139.5
                    let ww = 139
                    let co = 0
                    const tot = value.n_asistentes > 12 ? 12 : value.n_asistentes

                    for (let i = 0; i < 12; i++) {

                      doc.line(14, pp, 30.5, pp)
                      doc.line(33.5, pp, 63.25, pp)
                      doc.line(64.75, pp, 103.5, pp)
                      doc.line(106.5, pp, 180, pp)
                      doc.line(183, pp, 201, pp)

                      doc.text("/", 64, pp, {
                        align: 'center',
                        baseline: 'bottom'
                      })
                      doc.text(`${i + 1}`, 10, pp, {
                        align: 'center',
                        baseline: 'bottom'
                      })

                      if (i < tot) {
                        doc.text(asistentes[i].dni, 22.25, ww, {
                          align: 'center',
                          baseline: 'bottom'
                        })
                        doc.text(asistentes[i].nombres, 143.25, ww, {
                          align: 'center',
                          baseline: 'bottom'
                        })
                        doc.setFontSize(6);
                        doc.text(asistentes[i].area, 48.375, ww - 3, {
                          align: 'center',
                          baseline: 'ideographic',
                          maxWidth: 28
                        })
                        doc.setFontSize(6.75)
                        doc.text(asistentes[i].cargo, 84.125, ww - 3, {
                          align: 'center',
                          baseline: 'ideographic',
                          maxWidth: 36
                        })
                        asistentes[i].firma_foto !== null && asistentes[i].firma_foto !== '' ? await doc.addImage("https://images.weserv.nl/?url=https://www.agvperu.com" + asistentes[i].firma_foto, "PNG", 186, ww - 8, 12, 8) : ""
                      }

                      pp = pp + 11
                      ww = ww + 11
                      co++
                    }

                    doc.setFont(undefined, 'bold')
                    doc.text("ACTIVIDAD:", 9, 51.75, { baseline: 'middle' })
                    doc.text("ACCIÓN CORRECTIVA:", 145.5, 51.75, { baseline: 'middle' })
                    doc.text("MODALIDAD DE LA CAPACITACIÓN:", 9, 59.75, { baseline: 'middle' })
                    doc.text("ESCUELA:", 106.5, 59.75, { baseline: 'middle' })
                    doc.text("CATEGORÍAS:", 9, 67.75, { baseline: 'middle' })
                    doc.text("FECHA:", 9, 79.75, { baseline: 'middle' })
                    doc.text("HORA INICIO:", 44, 79.75, { baseline: 'middle' })
                    doc.text("HORA TÉRMINO:", 97, 79.75, { baseline: 'middle' })
                    doc.text("TIEMPO ESTIMADO:", 151, 79.75, { baseline: 'middle' })
                    doc.text("SEDE:", 9, 87.75, { baseline: 'middle' })
                    doc.text("DEPARTAMENTO:", 57.75, 87.75, { baseline: 'middle' })
                    doc.text("ÁREA:", 155.25, 87.75, { baseline: 'middle' })
                    doc.text("SECCIÓN:", 9, 95.75, { baseline: 'middle' })
                    doc.text("ZONA:", 99, 95.75, { baseline: 'middle' })
                    doc.text("GRUPO OBJETIVO:", 139, 95.75, { baseline: 'middle' })
                    doc.text("CULTIVO:", 9, 103.75, { baseline: 'middle' })
                    doc.text("UNIDAD:", 106.5, 103.75, { baseline: 'middle' })

                    doc.text("N°", 9, 126.75, { baseline: 'middle' })
                    doc.text("DNI", 22.25, 126.75, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("FIRMA", 191.25, 126.75, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("ÁREA / CARGO", 68.5, 126.75, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("APELLIDOS Y NOMBRES", 138, 126.75, {
                      align: 'center',
                      baseline: 'middle'
                    })

                    doc.text("NOMBRE DEL EXPOSITOR", 56.25, 117.25, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("INSTITUCIÓN DE PROCEDENCIA", 153.75, 117.25, {
                      align: 'center',
                      baseline: 'middle'
                    })

                    doc.setFont(undefined, 'normal')
                    doc.text("Inducción", 30, 51.75, { baseline: 'middle' })
                    doc.rect(41, 50.5, 2.5, 2.5)
                    value.actividad === 'INDUCCIÓN' ? doc.text("X", 42.25, 51.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Capacitación", 47.25, 51.75, { baseline: 'middle' })
                    doc.rect(62, 50.5, 2.5, 2.5)
                    value.actividad === 'CAPACITACIÓN' ? doc.text("X", 63.25, 51.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Entrenamiento", 68.25, 51.75, { baseline: 'middle' })
                    doc.rect(84.75, 50.5, 2.5, 2.5)
                    value.actividad === 'ENTRENAMIENTO' ? doc.text("X", 86, 51.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Simulacro", 91, 51.75, { baseline: 'middle' })
                    doc.rect(102.75, 50.5, 2.5, 2.5)
                    value.actividad === 'SIMULACRO' ? doc.text("X", 104, 51.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Charla", 109, 51.75, { baseline: 'middle' })
                    doc.rect(117.25, 50.5, 2.5, 2.5)
                    value.actividad === 'CHARLA' ? doc.text("X", 118.5, 51.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("SI", 178, 51.75, { baseline: 'middle' })
                    doc.rect(181.25, 50.5, 2.5, 2.5)
                    value.fecha_ejecucion === 'SI' ? doc.text("X", 182.5, 51.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("NO", 187.75, 51.75, { baseline: 'middle' })
                    doc.rect(192.5, 50.5, 2.5, 2.5)
                    value.fecha_ejecucion === 'NO' ? doc.text("X", 193.75, 51.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Interna", 58.5, 59.75, { baseline: 'middle' })
                    doc.rect(67.25, 58.5, 2.5, 2.5)
                    value.modalidad === 'INTERNA' ? doc.text("X", 68.5, 59.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Inhouse", 73.5, 59.75, { baseline: 'middle' })
                    doc.rect(83.5, 58.5, 2.5, 2.5)
                    value.modalidad === 'INHOUSE' ? doc.text("X", 84.75, 59.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("SIG", 124, 59.75, { baseline: 'middle' })
                    doc.rect(129.25, 58.5, 2.5, 2.5)
                    value.escuela === 'SISTEMA INTEGRADO DE GESTIÓN' ? doc.text("X", 130.5, 59.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Técnica", 135.5, 59.75, { baseline: 'middle' })
                    doc.rect(144.75, 58.5, 2.5, 2.5)
                    value.escuela === 'TÉCNICA' ? doc.text("X", 146, 59.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Gestión y Liderazgo", 151, 59.75, { baseline: 'middle' })
                    doc.rect(173.25, 58.5, 2.5, 2.5)
                    value.escuela === 'GESTIÓN Y LIDERAZGO' ? doc.text("X", 174.5, 59.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("Otros", 179.5, 59.75, { baseline: 'middle' })
                    doc.rect(186.25, 58.5, 2.5, 2.5)
                    value.escuela === 'OTROS' ? doc.text("X", 187.5, 59.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("SEGURIDAD Y SALUD EN EL TRABAJO", 32.5, 67.75, { baseline: 'middle' })
                    doc.rect(78.25, 66.5, 2.5, 2.5)
                    value.categoria === 'SEGURIDAD Y SALUD EN EL TRABAJO' ? doc.text("X", 79.5, 67.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("BRCGS/IFS", 84.75, 67.75, { baseline: 'middle' })
                    doc.rect(95.5, 66.5, 2.5, 2.5)
                    value.categoria === 'BRCGS/IFS' ? doc.text("X", 96.75, 67.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("GLOBAL GAP", 102, 67.75, { baseline: 'middle' })
                    doc.rect(118.5, 66.5, 2.5, 2.5)
                    value.categoria === 'GLOBAL GAP' ? doc.text("X", 119.75, 67.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("BASC", 125, 67.75, { baseline: 'middle' })
                    doc.rect(132.5, 66.5, 2.5, 2.5)
                    value.categoria === 'BASC' ? doc.text("X", 133.75, 67.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("FSMA", 139, 67.75, { baseline: 'middle' })
                    doc.rect(147, 66.5, 2.5, 2.5)
                    value.categoria === 'FSMA' ? doc.text("X", 148.25, 67.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("BPM", 153.5, 67.75, { baseline: 'middle' })
                    doc.rect(160, 66.5, 2.5, 2.5)
                    value.categoria === 'BPM' ? doc.text("X", 161.25, 67.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("HACCP", 166.5, 67.75, { baseline: 'middle' })
                    doc.rect(176, 66.5, 2.5, 2.5)
                    value.categoria === 'HACCP' ? doc.text("X", 177.25, 67.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("GESTIÓN AMBIENTAL", 32.5, 71.75, { baseline: 'middle' })
                    doc.rect(58.75, 70.5, 2.5, 2.5)
                    value.categoria === 'GESTIÓN AMBIENTAL' ? doc.text("X", 60, 71.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("RESPONSABILIDAD SOCIAL", 65.25, 71.75, { baseline: 'middle' })
                    doc.rect(98.75, 70.5, 2.5, 2.5)
                    value.categoria === 'RESPONSABILIDAD SOCIAL' ? doc.text("X", 100, 71.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("PROCESO TÉCNICO", 105.25, 71.75, { baseline: 'middle' })
                    doc.rect(129.75, 70.5, 2.5, 2.5)
                    value.categoria === 'PROCESO TÉCNICO' ? doc.text("X", 131, 71.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text("OTROS", 136.25, 71.75, { baseline: 'middle' })
                    doc.rect(145.75, 70.5, 2.5, 2.5)
                    value.categoria === 'OTROS' ? doc.text("X", 147, 71.75, {
                      align: 'center',
                      baseline: 'middle'
                    }) : ""

                    doc.text(value.fecha != null ? value.fecha : "--", 20, 79.75, { baseline: 'middle' })
                    doc.text(value.hora_inicio != null ? value.hora_inicio : "--", 61.25, 79.75, { baseline: 'middle' })
                    doc.text(value.hora_fin != null ? value.hora_fin : "--", 118, 79.75, { baseline: 'middle' })
                    doc.text(value.total_horas != null ? value.total_horas : "--", 176.25, 79.75, { baseline: 'middle' })
                    doc.text(value.sede != null ? value.sede : "--", 17, 87.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 37.5
                    })
                    doc.text(value.departamento != null ? value.departamento : "--", 80, 87.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 72.5
                    })
                    doc.text(value.area != null ? value.area : "--", 164.5, 87.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 36
                    })
                    doc.text(value.seccion != null ? value.seccion : "--", 22, 95.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 72.5
                    })
                    doc.text(value.zona != null ? value.zona : "--", 107.75, 95.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 72.5
                    })
                    doc.text(value.planilla != null ? value.planilla : "--", 162.5, 95.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 72.5
                    })
                    doc.text(value.cultivo != null ? value.cultivo : "--", 21.25, 103.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 72.5
                    })
                    doc.text(value.unidad != null ? value.unidad : "--", 117.25, 103.75, {
                      align: 'justify',
                      baseline: 'middle',
                      maxWidth: 72.5
                    })
                    doc.text(value.expositor != null ? value.expositor : "--", 56.25, 114, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text(value.procedencia_expositor != null ? value.procedencia_expositor : "--", 153.75, 114, {
                      align: 'center',
                      baseline: 'middle'
                    })

                  } else {
                    doc.addPage()
                    doc.setLineWidth(0.4)
                    doc.rect(7.5, 7.5, 195, 15)
                    doc.setLineWidth(0.225)
                    doc.line(46.5, 7.5, 46.5, 22.5)
                    doc.line(163.5, 7.5, 163.5, 22.5)
                    doc.line(46.5, 15, 163.5, 15)

                    doc.addImage(imgLogo, "PNG", 20.5, 8.5, 13, 13, "agv", "NONE", 0)
                    doc.addImage(imgSello, "PNG", 180, 276, 13, 13, "selloagv", "NONE", 0)
                    value.firma_expositor !== null && value.firma_expositor !== '' ? await doc.addImage("https://images.weserv.nl/?url=" + value.firma_expositor, "PNG", 50.5, 268.5, 20, 13, "firmaexp", "NONE", 0) : ""

                    doc.setFontSize(8)
                    doc.text("FORMATO", 105, 11.25, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("REGISTRO DE INDUCCIÓN, CAPACITACIÓN, ENTRENAMIENTO Y SIMULACRO", 105, 18.75, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.setFontSize(6);
                    doc.text(`Código: GH-GD-FO-0609\nRevisión: 006\nFecha: 03/12/2021\nPágina: ${j} de ${totalHojas}`, 165, 12.125, { align: 'left' })

                    doc.line(182.5, 28.5, 202.5, 28.5)
                    doc.text(value.n_acta != null ? `${value.n_acta.toString()
                        .padStart(6, '0')}` : '0'.padStart(6, '0'), 192.5, 27.75, { align: 'center' })
                    doc.setFont(undefined, 'bold')
                    doc.text("CÓDIGO DE ACTA: ", 181.5, 27.75, { align: 'right' })
                    doc.setFontSize(8)
                    doc.text("LISTA DE PARTICIPANTES", 110, 33, { align: 'center' })

                    doc.text("N°", 9, 40, { baseline: 'middle' })
                    doc.text("DNI", 22.25, 40, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("FIRMA", 191.25, 40, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("ÁREA / CARGO", 68.5, 40, {
                      align: 'center',
                      baseline: 'middle'
                    })
                    doc.text("APELLIDOS Y NOMBRES", 138, 40, {
                      align: 'center',
                      baseline: 'middle'
                    })

                    doc.line(40, 282.5, 80, 282.5)
                    doc.text("FIRMA DEL EXPOSITOR", 60, 285.75, {
                      align: 'center',
                      baseline: 'bottom'
                    })
                    doc.text(value.dni_expositor != null ? `DNI: ${value.dni_expositor}` : "DNI: --", 60, 289.5, {
                      align: 'center',
                      baseline: 'bottom'
                    })

                    doc.line(110, 289.5, 170, 289.5)
                    doc.line(110, 286, 170, 286)
                    doc.line(110, 282.5, 170, 282.5)
                    doc.line(110, 279, 170, 279)
                    doc.line(110, 275.5, 170, 275.5)

                    doc.line(110, 275.5, 110, 289.5)
                    doc.line(170, 275.5, 170, 289.5)

                    doc.setFont(undefined, 'normal')
                    doc.setFontSize(4.5);
                    doc.text(`NÚMERO DE CAPACITADOS: ${value.n_asistentes}`, 111.5, 278, { baseline: 'bottom' })
                    doc.text("RAZON SOCIAL: Agrovision Perú S.A.C", 111.5, 281.5, { baseline: 'bottom' })
                    doc.text("RUC: 20554556192    DIRECCIÓN: Jacarandas #490", 111.5, 285, { baseline: 'bottom' })
                    doc.text("ACTIVIDAD DE LA EMPRESA: Agroindustria", 111.5, 288.5, { baseline: 'bottom' })

                    let pp = 52.75
                    let ww = 52.25
                    let co = 0
                    const tot = value.n_asistentes

                    ini = ini + 20
                    fin = fin + 20

                    doc.setFontSize(6);
                    for (let i = ini; i <= fin; i++) {

                      doc.line(14, pp, 30.5, pp)
                      doc.line(33.5, pp, 63.25, pp)
                      doc.line(64.75, pp, 103.5, pp)
                      doc.line(106.5, pp, 180, pp)
                      doc.line(183, pp, 201, pp)

                      doc.text("/", 64, pp, {
                        align: 'center',
                        baseline: 'bottom'
                      })
                      doc.text(`${i}`, 10, pp, {
                        align: 'center',
                        baseline: 'bottom'
                      })

                      if (i <= tot) {
                        doc.text(asistentes[i - 1].dni, 22.25, ww, {
                          align: 'center',
                          baseline: 'bottom'
                        })
                        doc.text(asistentes[i - 1].nombres, 143.25, ww, {
                          align: 'center',
                          baseline: 'bottom'
                        })
                        doc.setFontSize(6);
                        doc.text(asistentes[i - 1].area, 48.375, ww - 3, {
                          align: 'center',
                          baseline: 'ideographic',
                          maxWidth: 28
                        })
                        doc.setFontSize(6.75)
                        doc.text(asistentes[i - 1].cargo, 84.125, ww - 3, {
                          align: 'center',
                          baseline: 'ideographic',
                          maxWidth: 36
                        })
                        asistentes[i - 1].firma_foto !== null && asistentes[i - 1].firma_foto !== '' ? await doc.addImage("https://images.weserv.nl/?url=https://www.agvperu.com" + asistentes[i - 1].firma_foto, "PNG", 186, ww - 8, 12, 8) : ""
                      }

                      pp = pp + 11
                      ww = ww + 11
                      co++
                    }

                  }
                }

                const nomms = value.n_acta != null ? value.n_acta.toString()
                    .padStart(6, '0') : '000000'
                doc.save("Reporte PDF Asistencias - N° " + nomms + " - " + value.empresa + ".pdf")
              }
            })
            .catch(function (error) {
              console.log(error);
            })
            .finally(function () {
              yo.loadingPDF = false
            });
      }
    },

    realizarFiltro(cabecera, data){
      const yo = this
      let spd = yo.items

      let filt = []
      let c = 0

      let fecha = yo.fechaFiltro
      let fechaInicio = ''
      let fechaFin = ''
      let fechaHoy = ''

      if(fecha !== null && fecha !== ''){
        fecha = fecha.split(' a ')
        if(fecha.length === 1){
          const [dia, mes, anio] = fecha[0].split('/');
          fechaInicio = new Date(+anio, mes - 1, +dia);
          fechaFin = new Date(+anio, mes - 1, +dia, 23, 59, 59);
        }else{
          const [dia, mes, anio] = fecha[0].split('/');
          const [dia1, mes1, anio1] = fecha[1].split('/');
          fechaInicio = new Date(+anio, mes - 1, +dia);
          fechaFin = new Date(+anio1, mes1 - 1, +dia1);
        }
      }

      for(const valor of yo.filtro){
        if (valor.nombre === cabecera){
          yo.filtro[c].valor = data
        }

        if(valor.nombre === 'fecha' && data.length === 0){
          yo.fechaFiltro = null
          yo.filtro[c].valor = data
        }

        c += 1;
      }

      for(const values of yo.filtro){
        for ( const column of values.valor ){
          spd.forEach(function(value) {
            if (column === 'VACIOS') {
              if (value[values.nombre] === null || value[values.nombre] === '' || value[values.nombre] === ' ' || value[values.nombre] === '  '){
                filt.push(value)
              }
            }else{
              if(values.nombre === 'fecha' && column !== null){
                const [anios, mess, dias] = value.fecha.split('-')
                fechaHoy = new Date(+anios, mess - 1, +dias)

                if (fechaInicio !== '' && fechaFin !== ''){
                  if(fechaHoy.getTime() >= fechaInicio.getTime() && fechaHoy.getTime() <= fechaFin.getTime()){
                    filt.push(value)
                  }
                }

              }else{
                if (value[values.nombre] === column){
                  filt.push(value)
                }
              }
            }
          })
        }

        if(values.valor.length > 0){
          if(values.valor[0] !== null){
            spd = filt
            filt = []
          }
        }
      }

      yo.itemsFiltro = spd

    },

    buscar(){
      const yo = this
      yo.loading = true
      // ----------------i

      const data = JSON.stringify(
          {
            "dni_nombre": yo.busqueda
          }
      )

      const config = {
        method: 'post',
        url: '/capacitacion/asistentes/filter/',
        headers: {
          'Content-Type': 'application/json'
        },
        data : data
      };

      axiosIns(config)
          .then(function (response) {
            if (response.status === 200) {
              // console.log(response.data)
              yo.itemsFiltro=response.data;
            }
          })
          .catch(function (error) {
            console.log(error);

          })
          .finally(function () {
            yo.loading = false
          });

    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.alinear-medioA{
  vertical-align: middle!important;
}
.alinear-una-sola-linea{
  white-space: nowrap!important;
}
.tablitaA{
  min-height: 58vh!important;
}

.tablitaA::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablitaA::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablitaA::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}
</style>
